import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: 'kxxtoumf',
  // "dev" is the permanent/production dataset — all content lives here now. The separate
  // "production" dataset in Sanity still exists but is unused and will be deleted later.
  dataset: 'dev',
  apiVersion: '2025-05-12',
  useCdn: true,
  perspective: 'raw',
});

// Get a pre-configured url-builder from your sanity client
const builder = imageUrlBuilder(client);

// Serves resized, modern-format (WebP/AVIF) images from Sanity's CDN instead of
// the original upload — pass `width` to cap the requested size for the image's
// actual rendered role (hero vs. carousel vs. thumbnail). SVGs (no width passed)
// pass through unaffected since there's no raster format to negotiate.
export const urlFor = (source, { width } = {}) => {
  if (!source) return null;
  let img = builder.image(source).auto('format').quality(80);
  if (width) img = img.width(width);
  return img.url();
};
